module.exports = __webpack_public_path__ + "img/logo-w.01099532.svg";